// extracted by mini-css-extract-plugin
module.exports = {"container":"SiteNavBDesktop_container__3sdF2"};